<mat-card class="medicine-create-view">
  <mat-card-title>
    New medicine
    @if (createdMedicine) {
      <span>
        - {{createdMedicine.name}}
      </span>
    }
  </mat-card-title>
  <mat-stepper linear #stepper>
    <mat-step [editable]="creatingMedicineIsEditable" [stepControl]="medicineForm">
      <ng-template matStepLabel>New medicine active</ng-template>
      <form autocomplete="off" [formGroup]="medicineForm">
        <div class="row">
          <div class="col-md-6">

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input required formControlName="name" type="text" matInput placeholder="Name">
                @if (medicineForm.get('name')?.invalid) {
                  <mat-error>
                    Name is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>

            <p>
              <mat-form-field appearance="outline">
                <mat-label>Barcode prefix</mat-label>
                <input required formControlName="barcodePrefix" type="text" matInput
                  placeholder="Barcode prefix">
                  @if (medicineForm.get('barcodePrefix')?.invalid) {
                    <mat-error>
                      Barcode prefix is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>

            </div>

            <div class="col-md-6">

              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Active ingredient</mat-label>
                  <input required formControlName="activeIngredient" type="text" matInput
                    placeholder="Active ingredient">
                    @if (medicineForm.get('activeIngredient')?.invalid) {
                      <mat-error>
                        Active ingredient is invalid
                      </mat-error>
                    }
                  </mat-form-field>
                </p>

                <p>
                  <mat-form-field appearance="outline">
                    <mat-label>Active ingredient nappy code</mat-label>
                    <input formControlName="activeIngredientNappyCode" type="text" matInput
                      placeholder="Active ingredient nappy code">
                      @if (medicineForm.get('activeIngredientNappyCode')?.invalid) {
                        <mat-error>
                          Active ingredient nappy code is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                </div>
              </div>

              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Schedule status</mat-label>
                  <mat-select required formControlName="scheduleStatus">
                    @for (status of scheduleStatuses; track status) {
                      <mat-option [value]="status">
                        {{status}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (medicineForm.get('scheduleStatus')?.invalid) {
                    <mat-error>
                      Schedule status is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>

              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Description</mat-label>
                  <textarea required formControlName="description" matInput placeholder="Description"></textarea>
                  @if (medicineForm.get('description')?.invalid) {
                    <mat-error>
                      Description is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>

              <p>
                <mat-checkbox formControlName="canOrder" color="primary">Can be Ordered</mat-checkbox>
              </p>

            </form>
            <div class="text-end mt-2">
              <button [disabled]="!medicineForm.valid" (click)="createMedicine()" mat-raised-button color="primary">
                <mat-icon>chevron_right</mat-icon> Next
              </button>
            </div>
          </mat-step>
          <mat-step [editable]="creatingMedicineDosageTypeIsEditable" [stepControl]="medicineDosageTypeForm">
            <ng-template matStepLabel>Medicine active dosage type</ng-template>
            <form autocomplete="off" [formGroup]="medicineDosageTypeForm">
              <div class="row">
                <div class="col-md-6">

                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Type</mat-label>
                      <mat-select required formControlName="dosageType">
                        @for (type of dosageTypes; track type) {
                          <mat-option [value]="type">
                            {{type.type}}
                          </mat-option>
                        }
                      </mat-select>
                      <button type="button" matSuffix mat-icon-button (click)="createDosageType($event)">
                        <mat-icon>add</mat-icon>
                      </button>
                      @if (medicineDosageTypeForm.get('dosageType')?.invalid) {
                        <mat-error>
                          Dosage type is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Display name</mat-label>
                      <input required type="text" formControlName="additionalInformation" matInput
                        placeholder="Display name">
                        @if (medicineDosageTypeForm.get('additionalInformation')?.invalid) {
                          <mat-error>
                            Display name is invalid
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>

                  </div>

                  <div class="col-md-6">
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Strength</mat-label>
                        <input required formControlName="dosageStrength" type="text" matInput
                          placeholder="Strength">
                          @if (medicineDosageTypeForm.get('dosageStrength')?.invalid) {
                            <mat-error>
                              Strength is invalid
                            </mat-error>
                          }
                        </mat-form-field>
                      </p>


                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Active</mat-label>
                          <mat-select formControlName="isActive">
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                          </mat-select>
                          @if (medicineDosageTypeForm.get('isActive')?.invalid) {
                            <mat-error>
                              Active is invalid
                            </mat-error>
                          }
                        </mat-form-field>
                      </p>

                    </div>
                  </div>

                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Usage instructions</mat-label>
                      <textarea required formControlName="usageInstructions" matInput
                      placeholder="Usage instructions"></textarea>
                      @if (medicineDosageTypeForm.get('usageInstructions')?.invalid) {
                        <mat-error>
                          Usage instructions is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Storage directions</mat-label>
                      <textarea required formControlName="storageDirections" matInput
                      placeholder="Storage directions"></textarea>
                      @if (medicineDosageTypeForm.get('storageDirections')?.invalid) {
                        <mat-error>
                          Storage directions is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Special instructions</mat-label>
                      <textarea formControlName="specialInstructions" matInput
                      placeholder="Special instructions"></textarea>
                      @if (medicineDosageTypeForm.get('specialInstructions')?.invalid) {
                        <mat-error>
                          Special instructions is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>

                </form>
                <div class="text-end mt-2">
                  <button mat-raised-button class="me-2" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon> Back
                  </button>
                  <button mat-raised-button [disabled]="!medicineDosageTypeForm.valid" color="primary"
                    (click)="createMedicineDosageType()">
                    <mat-icon>chevron_right</mat-icon> Next
                  </button>
                </div>
              </mat-step>
              <mat-step [stepControl]="medicineDosagePackageTypeForm">
                <ng-template matStepLabel>Medicine package types</ng-template>
                <form [formGroup]="medicineDosagePackageTypeForm">
                  <div class="row">

                    <p class="col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Label name</mat-label>
                        <input required formControlName="labelName" placeholder="Label name" type="text" matInput>
                        @if (medicineDosagePackageTypeForm.get('labelName')?.invalid) {
                          <mat-error>
                            Label name is invalid {{labelNameExceeds25Chars ? ": Max 25 characters allowed" : ""}}
                          </mat-error>
                        }
                        <mat-hint>Maximum of 25 characters</mat-hint>
                      </mat-form-field>
                    </p>

                    <p class="col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Price</mat-label>
                        <input required formControlName="price" placeholder="Price" type="number" matInput>
                        @if (medicineDosagePackageTypeForm.get('price')?.invalid) {
                          <mat-error>
                            Price is invalid
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>

                    <p class="col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Package type</mat-label>
                        <mat-select required formControlName="packageType">
                          @for (type of packageTypes; track type) {
                            <mat-option [value]="type">
                              {{type.type}}
                            </mat-option>
                          }
                        </mat-select>
                        <button type="button" matSuffix mat-icon-button (click)="createPackageType($event)">
                          <mat-icon>add</mat-icon>
                        </button>
                        @if (medicineDosagePackageTypeForm.get('packageType')?.invalid) {
                          <mat-error>
                            Package type is invalid
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>

                    <p class="col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Quantity</mat-label>
                        <input required formControlName="containedQuantity" placeholder="Quantity" type="number" step="0.01"
                          matInput>
                          <span matSuffix>{{currentDosageUnit ? currentDosageUnit.unit : "-"}}</span>
                          @if (medicineDosagePackageTypeForm.get('containedQuantity')?.invalid) {
                            <mat-error>
                              Quantity is invalid
                            </mat-error>
                          }
                        </mat-form-field>
                      </p>

                    </div>
                  </form>

                  <button mat-stroked-button [disabled]="!medicineDosagePackageTypeForm.valid"
                    (click)="createMedicineDosagePackageType()">
                    <mat-icon>add</mat-icon> Add package type
                  </button>

                  <!--List out the package types :)-->
                  @if (createdMedicineDosageType && createdMedicine) {
                    <core-medicine-dosage-package-type-list [dosageUnit]="currentDosageUnit" (onUpdated)="onDosagePackageTypesUpdated($event)"
                      [medicineDosageTypeId]="createdMedicineDosageType.id" [packageTypes]="packageTypes"
                      [medicineId]="createdMedicine.id" [medicineDosagePackageTypes]="medicineDosagePackageTypes">
                    </core-medicine-dosage-package-type-list>
                  }
                  <div class="text-end mt-2">
                    <button mat-raised-button (click)="redirect()" color="primary">
                      <mat-icon>done</mat-icon> Done
                    </button>
                  </div>
                </mat-step>
              </mat-stepper>
            </mat-card>